export const react_domain = `${window.location.origin}`;
// export const react_domain = `http://localhost:3000`;


export const smartAlogUrl = `https://crypto.deepmindinfotech.com/backend/`;

// export const socket_url =  window.location.hostname === "localhost" ? "https://crypto.deepmindinfotech.com:1001" : `${window.location.origin}:1001`

export const socket_url = "https://crypto.deepmindinfotech.com:1001"



export const base_url =
  window.location.hostname === "localhost"
    ? "http://localhost:7700/"
    : `${window.location.origin}/backend/`;




// export const base_url =`https://crypto.thewintex.com/backend/`
// export const base_url =`https://crypto.algobuzztechnology.com/backend/`
// export const base_url =`https://coin.goproalgo.com/backend/`
// export const base_url =`https://trade.fxitstack.com/backend/`
// export const base_url =`https://crypto.algobuzztechnology.com/backend/`





 